<template>
   
    <div class="container mt-2 justify-content-center">
     <div class="row ">




    <div class="col-6 mt-3"> 


          <!-- Button trigger modal -->
<button type="button" @click="addCorrespondence()" class="btn btn-success" data-bs-toggle="modal" data-bs-target="#exampleModal">
 დამატება
</button>

<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
      
        <div class="mb-3 mt-3">
  
  <input type="text" class="form-control"    placeholder=" გამომგზავნი" v-model="sender">
 
</div>
<div class="mb-3">

  <input type="text" class="form-control"  placeholder="მიმღები პირი" v-model="receiver">
</div>

  <div class="mb-3">

    <textarea rows="2" cols="50"  v-model="description" class="form-control" placeholder="შინაარსი">
</textarea>
 
</div>
<!-- <div class="mb-3">
 <p>თარიღი</p>
<input type="date" class="form-control" v-model="correspondence_date">

</div> -->
<div class="mb-3">

  <input type="file" class="form-control" @change="getCorrespondenceFile">

</div>
        
        


      </div>
      <div class="modal-footer">
        
        <button v-if="!isReadyForEdit" type="button" class="btn btn-success" @click="saveExternalCorrespondence()">შენახვა</button>
        <button v-else type="button" class="btn btn-success" @click="goEditExternalCorrespondence(editedCorrespondenceID)">რედაქტირება</button>
      </div>
    </div>
  </div>
</div>
 
           
         
        </div> 
             <div class="col-12 mt-3">

                    <div class="row">
                  <div class="col-4 mb-2 d-grid" v-for="years of externalCorrespondenceYears">
                    <button @click="showExternalCorrespondence(years.externalCorrespondenceYear)" class="btn btn-success">{{ years.externalCorrespondenceYear }}</button>
                  </div>
              </div>
 
                 <table class="table" v-if="externalCorrespondences.length>0">
   <thead>
     <tr>
   
        
       <th scope="col"> გამომგზავნი</th>
       <th scope="col">მიმღები პირი</th>
       <th scope="col">შინაარსი</th>
       <th scope="col">დაწერის თარიღი</th>
       <th scope="col">მიმაგრებული ფაილი</th>
      
 
     </tr>
   </thead>
   <tbody>
     
     <tr v-for="externalCorrespondence in externalCorrespondences" :key="externalCorrespondence.external_correspondenceID">
 
    
       <td>{{ externalCorrespondence.sender }}</td>
       <td>{{ externalCorrespondence.receiver }}</td>
       <td>{{ externalCorrespondence.description }}</td>
       <td>{{ externalCorrespondence.correspondence_date }}</td>
       <td><a :href="'https://api.ugcollege.ug.edu.ge/storage/externalCorrespondence/'+externalCorrespondence.correspondence_file" target="_blank">მიმაგრებული ფაილი</a></td>
       <td><button v-if="this.$store.state.user.positionID==1" type="button" class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="editCorrespondece(externalCorrespondence)"><i class='bx bxs-edit-alt'></i></button> </td>
       <td> <button v-if="this.$store.state.user.positionID==1" type="button" class="btn btn-outline-success" @click="deleteCorrespondence(externalCorrespondence.external_correspondenceID)"><i class='bx bx-x'></i></button></td>
    
     </tr>
     
   
 
   </tbody>
 </table>
             </div>
 
     </div>
    </div>
  
 
 </template>
 <script>

import HttpRequests from '../httpRequests/httpRequests'
const httpRequests=new HttpRequests()
  export default{
    data(){
      return{
        sender:null,
        receiver:null,
        description:null,
        correspondence_date:null,
        correspondeceFile:null,
        externalCorrespondences:[],

        isReadyForEdit:false,
        editedCorrespondenceID:0,
        externalCorrespondenceYears:[]

      }
    },
    mounted(){

    httpRequests.getExternalCorrespondenceYears().then(response=>{
      this.externalCorrespondenceYears=response.data
    })

    },
    methods:{

      showExternalCorrespondence(year){
          httpRequests.getExternalCorrespondence(year).then(response=>{
                  this.externalCorrespondences=this.enumerateRowsByYear(response.data)
              })
      },

enumerateRowsByYear(data) {
  // Step 1: Process in reverse (oldest to newest)
  const reversed = [...data].reverse();
  let currentYear = null;
  let counter = 0;

  const processed = reversed.map(row => {
    const year = new Date(row.correspondence_date).getFullYear();
    if (year !== currentYear) {
      currentYear = year;
      counter = 1;
    } else {
      counter++;
    }
    return { ...row, row_number: counter };
  });

  // Step 2: Reverse back to original (newest to oldest)
  return processed.reverse();
},



      getCorrespondenceFile(e){
        this.correspondeceFile=e.target.files[0]
      },
      saveExternalCorrespondence(){
        let formData=new FormData()

        formData.append('sender',this.sender)
        formData.append('receiver',this.receiver)
        formData.append('description',this.description)
        formData.append('correspondence_date',this.correspondence_date)
        formData.append('correspondeceFile',this.correspondeceFile)

        httpRequests.saveExternalCorrespondence(formData).then(()=>{
          location.reload()
        })
        
      },
      editCorrespondece(correspondece){
        this.isReadyForEdit=true
        this.editedCorrespondenceID=correspondece.external_correspondenceID
        this.sender=correspondece.sender
        this.receiver=correspondece.receiver
        this.description=correspondece.description
        this.correspondence_date=correspondece.correspondence_date
      },
      addCorrespondence(){
        this.isReadyForEdit=false
        this.editedCorrespondenceID=0
        this.sender=null
        this.receiver=null
        this.description=null
        this.correspondence_date=null
      },
      goEditExternalCorrespondence(correspondenceID){

        let formData=new FormData()

          formData.append('sender',this.sender)
          formData.append('receiver',this.receiver)
          formData.append('description',this.description)
          formData.append('correspondence_date',this.correspondence_date)
          formData.append('correspondeceFile',this.correspondeceFile)
          formData.append('external_correspondenceID',correspondenceID)

          httpRequests.goEditExternalCorrespondence(formData).then(()=>{
            location.reload()
          })


      },
      deleteCorrespondence(correspondenceID){

        if(confirm("ნამდვილად გსურთ წაშლა?")){
          httpRequests.deleteCorrespondence(correspondenceID).then(()=>{
            location.reload()
          })
        }

      }
    }
  }

</script>